import { motion } from "framer-motion";

const EASE_OUT = [0.16, 1, 0.3, 1] as const;

interface Stat {
  value: string;
  label: string;
}

const STATS: Stat[] = [
  { value: "30K+", label: "YouTube subscribers" },
  { value: "10,000+", label: "Client hours automated" },
  { value: "$1.5M+", label: "Est. value of time recovered" },
  { value: "Multiple", label: "Industries served" },
];

export default function Stats() {
  return (
    <section className="bg-ink border-t border-ink-3">
      <div className="max-w-7xl mx-auto px-6 lg:px-16 py-12 lg:py-16">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-ink-3">
          {STATS.map((stat, i) => (
            <motion.div
              key={stat.label}
              className="bg-ink flex flex-col items-start px-5 py-8 lg:px-8 lg:py-10"
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: i * 0.08, ease: EASE_OUT }}
              viewport={{ once: true, margin: "-40px" }}
            >
              <span className="font-display font-bold text-4xl lg:text-5xl text-chalk tracking-tightest leading-none">
                {stat.value}
              </span>
              <span className="mt-3 font-mono text-[10px] lg:text-xs text-chalk-3 tracking-widest uppercase">
                {stat.label}
              </span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
